var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section paywall-devices row paywall-section" },
    [
      _c("div", { staticClass: "container" }, [
        _c("h2", [_vm._v("All access. All devices. One subscription.")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("ResponsiveImage", {
              staticClass: "no-zoom",
              attrs: {
                src: [
                  "/site_media/version-8faca430ec/images/paywall/pix-devices-1x.png",
                  "/site_media/version-5eabd18a1b/images/paywall/pix-devices-2x.png"
                ],
                alt: "Brilliant on different devices"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "Button",
              {
                attrs: { primary: "", green: "" },
                on: { click: _vm.handleClick }
              },
              [_vm._v(_vm._s(_vm.ctaText))]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }